import { render, staticRenderFns } from "./AccessControlRecord.vue?vue&type=template&id=12507e6e&scoped=true"
import script from "./AccessControlRecord.vue?vue&type=script&lang=js"
export * from "./AccessControlRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12507e6e",
  null
  
)

export default component.exports